export default "__VITE_ASSET__DEMon970__"